// extracted by mini-css-extract-plugin
export default {"questionContent":"CategoryInfo_questionContent__VDO1s","iconImg":"CategoryInfo_iconImg__bpV7j","imgShapes":"CategoryInfo_imgShapes__Ma6-C","infoCard":"CategoryInfo_infoCard__lhzBs"};